import { AllowedVal } from '@ntap/core';

export function normalizeOptionLabel(option: AllowedVal) {
  return normalizeLabel(option.label);
}

export function normalizeLabel(value: string) {
  return value
    .trim()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replaceAll(/\s/g, '-');
}

export function isRootJedinica(item: any) {
  if (
    Object.keys(item).indexOf(
      'en~jedinica_gradiva~nadredena_jedinica_gradiva'
    ) >= 0
  ) {
    return !item['en~jedinica_gradiva~nadredena_jedinica_gradiva'];
  }
  return false;
}

export function isNerazvrstanoJedinica(item: any): boolean {
  const arhivskaOznaka = item['en~jedinica_gradiva~arhivska_oznaka'] || '';
  return arhivskaOznaka.includes('Nerazvrstano-');
}
